import Vue from 'vue';
import Component from 'vue-class-component';
import { CORE_ROUTES } from '@/core/core.router';
import { INVITATION_STATUS, EDUAC_URL } from '@/auth/values/auth.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

@Component({
  name: 'complete-invitation',
  components: {
  },
})
export default class CompleteInvitationView extends Vue {

  /* Data */
  public sending: boolean = false;
  public eduacURL: any = EDUAC_URL.URL;
  public orgName: string = ''

  /* Computed */
  get invitationId() {
    return this.$route.params.invitationId;
  }
  
  get invitationType() {
    return this.$route.query.type;
  }

  /* Methods */
  acceptInvitation() {
    this.$EdModal.createConfirmationModal(
      {
        title: this.$i18n.t('auth.register.register'),
        body: `${this.$t('auth.register.info.acceptInvitationConfirm')}`, 
        action: this.acceptInvitationConfirm
      }
    );
  }

  async acceptInvitationConfirm() {
    try {
      if (this.$route.name.includes('complete')) {
        this.$router.push({ 
          name: CORE_ROUTES.PUBLIC.COMPLETE_USER_INVITATION.NAME,
          query: { invitationId: this.invitationId }  
        })
      } else  {
        await this.$Auth.Services.respondInvitation(this.$route.params.invitationId, INVITATION_STATUS.APPROVED);
        this.goHome();
      }
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('auth.register.errors.invitationNoAccepted')}`,
        type: TOAST_TYPES.DANGER,
        top: '5.5rem',
        timeout: 3000
      });
    }
  }

  passInvitation() {
     this.$EdModal.createConfirmationModal(
      {
        title: this.$i18n.t('auth.register.register'),
        body: `${this.$t('auth.register.info.passInvitationConfirm')}`, 
        action: this.passInvitationConfirm
      }
    );
  }

  async passInvitationConfirm() {
    try {
      await this.$Auth.Services.respondInvitation(this.$route.params.invitationId, INVITATION_STATUS.REJECTED);
      this.goHome();
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('auth.register.errors.invitationNoDeclined')}`,
        type: TOAST_TYPES.DANGER,
        top: '5.5rem',
        timeout: 3000
      });
    }
  }

  goHome() {
    this.$router.push({ name: CORE_ROUTES.HOME.NAME })
  }

  beforeMount () {
    const $root: any = this.$root;
    $root.logout(false)
  }

  async mounted() {
    let invitation = await this.$Auth.Services.getInvitationByHash(this.$route.params.invitationId);
    this.orgName = invitation.organizationName;
  }
}